<template>
  <div>
    <div v-if="step === steps.NOTHING" @click="step = steps.FORGOTTEN" class="clickable">
      <span>
        Mot de passe oublié ?
      </span>
    </div>
    <div v-else-if="step === steps.FORGOTTEN" style="width: 100%">
      <div>
        A quelle adresse est associée ton compte ? Un mail te sera envoyé pour réinitialiser ton mot de passe.
      </div>
      <div class="form-body">
        <div class="mail-icon smallMargin align-center">
          <i class="fas fa-envelope"></i>
        </div>
        <div class="forgotten-mail-input align-center">
          <form style="width: 100%">
            <input type="email" v-model.trim="mail" class="smallRoundAngles smallMargin" style="flex-grow: 1" placeholder="Email">
          </form>
        </div>

        <div @click="sendMail" class="envoyer align-center smallRoundAngles paddingRound smallMargin clickable mediumShadow">
          <div class="flexwrap centercenter">
            <strong>
              <span>Envoyer</span>
            </strong>
          </div>
        </div>
      </div>
    </div>
    <div v-else-if="step === steps.MAIL_SENT">
      <span>
        Le mail a bien été envoyé à l'adresse indiquée : {{mail}}
      </span>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
name: "passwordForgotten",

  computed: {
    ...mapGetters('global', [
      'isMobile',
    ]),
  },

  methods: {
  checkMailFormat: function() {
    return this.mail.match(
        /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
  },

    sendMail: function() {
      this.$webAuth.changePassword({
        connection: 'Username-Password-Authentication',
        email:   this.mail
      }, (err, resp) => {
        if(err){
          console.log(err.message);
        }else{
          console.log(resp);
          this.step = this.steps.MAIL_SENT
        }
      });
    }
  },

  data() {
    return {
      isForgotten: false,
      mail: '',
      step: 0,
      steps: {
        NOTHING: 0,
        FORGOTTEN: 1,
        MAIL_SENT: 2
      }
    }
  }
}
</script>

<style scoped>
input {
  width: fill-available;
  font-size: 1vw;
  border: 1px solid silver;
  background: whitesmoke;
  padding: 5px 10px;
}

input:focus {
  background: white;
}

  .form-body {
    display: grid;
    grid-template-columns: max-content auto;
    grid-template-rows: auto auto;
  }

  .mail-icon {
    width: max-content;
    grid-row: 1/2;
    grid-colum: 1/2
  }

  .mail-line {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .forgotten-mail-input {
    grid-row: 1/2;
    grid-column: 2/3;
  }

  .envoyer {
    grid-column: 2/3;
    grid-row: 2/3;
    background-color: var(--goalBackgroundColor2);
    color: var(--goalColor);
  }

@media screen and (max-device-width: 767px) {
  input {
    width: fill-available;
    font-size: 4vw;
    border: 1px solid silver;
    background: whitesmoke;
    padding: 5px 10px;
  }
}
</style>